
export const common =  {
    "请求延时": "Yêu cầu chờ lâu",
    "操作成功": "Thành công",
    "暂无数据": "Chưa có dữ liệu",
    "请输入": "Vui lòng nhập",
    "copyok": "Sao chép thành công",
    "copyerror": "Sao chép thất bại"
  };

 export const tableList = {
  '跟单交易量':'Sao chép khối lượng giao dịch',
  '跟单总交易量':'Tổng khối lượng giao dịch sao chép',
  用户昵称: "Biệt danh người dùng",
    "持仓": "Vị thế",
    "仓位": "Kích thước vị thế",
    "当前委托": "Lệnh hiện tại",
    "当前计划": "Kế hoạch hiện tại",
    "历史仓位": "Lịch sử vị thế",
    "账单": "Ghi chú tài chính",
    "全部平仓": "Bán hết vị thế",
    "全部撤单": "Hủy tất cả lệnh",
    "合约名称": "Tên hợp đồng",
    "创建时间": "Thời gian tạo",
    "方向": "Hướng",
    "杠杆": "Đòn bẩy",
    "保证金": "Tạm giữ",
    "开仓价格": "Giá mở",
    "开仓均价": "Giá trung bình mở",
    "全仓风险率": "Tỷ lệ rủi ro toàn bộ",
    "预估爆仓价": "Giá ước tính chấp nhận",
    "收益率": "Tỷ suất lợi nhuận",
    "平仓价格": "Giá đóng",
    "预计强平价": "Giá ước tính chấp nhận mạnh",
    "持仓数量": "Số lượng vị thế",
    "张": "Lô",
    "风险率": "Tỷ lệ rủi ro",
    "保证金率": "Tỷ lệ tạm giữ",
    "预计止盈价": "Giá dừng lợi nhuận dự kiến",
    "预计止损价": "Giá dừng lỗ dự kiến",
    "浮动盈亏": "Lãi/lỗ động",
    "平仓盈亏": "Lãi/lỗ đóng",
    "盈亏": "Lãi/lỗ",
    "委托数量": "Số lượng ủy nhiệm",
    "委托价格": "Giá ủy nhiệm",
    "成交价格": "Giá thực hiện",
    "成交均价": "Giá trung bình thực hiện",
    "止盈价": "Giá dừng lợi nhuận",
    "止损价": "Giá dừng lỗ",
    "执行价": "Giá thực hiện",
    "触发条件": "Điều kiện kích hoạt",
    "操作": "Hoạt động",
    "手续费": "Phí giao dịch",
    "平仓类型": "Loại đóng",
    "类型": "Loại",
    "数量": "Số lượng",
    "逐仓做多": "Mua dài theo vị thế",
    "逐仓做空": "Bán ngắn theo vị thế",
    "全仓做多": "Mua dài toàn bộ",
    "全仓做空": "Bán ngắn toàn bộ",
    "永续合约": "Hợp đồng vô thời hạn",
    "手动平仓": "Đóng vị thế bằng tay",
    "市价平仓": "Đóng vị thế thị trường",
    "限价平仓": "Đóng vị thế giới hạn",
    "止盈": "Dừng lợi nhuận",
    "止损": "Dừng lỗ",
    "手动撤销": "Hủy bỏ bằng tay",
    "自动减仓": "Tự động giảm vị thế",
    "强制减仓": "Giảm vị thế bắt buộc",
    "强制平仓": "Đóng vị thế bắt buộc",
    "资金不足系统撤单": "Hủy lệnh do thiếu tiền",
    "资金超限系统撤单": "Hủy lệnh do vượt quá hạn mức tiền",
    "撤单": "Hủy lệnh",
    "平仓": "Đóng vị thế",
    "更多": "Thêm",
    "部分平仓": "Đóng vị thế một phần",
    "反向开仓": "Mở vị thế ngược",
    "加仓": "Mở thêm vị thế",
    "一键平仓": "Đóng vị thế một chạm",
    "最新价": "Giá mới nhất",
    "体验金平仓": "Đóng vị thế trong vòng 24 giờ",
    "下单时间": "Thời gian đặt lệnh",
    "交易类型": "Loại giao dịch",
    "委托类型": "Loại ủy nhiệm",
    "成交类型": "Loại thực hiện",
    "逐仓平多": "Đóng vị thế mua dài theo vị thế",
    "逐仓开多": "Mở vị thế mua dài theo vị thế",
    "逐仓平空": "Đóng vị thế bán ngắn theo vị thế",
    "逐仓开空": "Mở vị thế bán ngắn theo vị thế",
    "全仓平多": "Đóng vị thế mua dài toàn bộ",
    "全仓开多": "Mở vị thế mua dài toàn bộ",
    "全仓平空": "Đóng vị thế bán ngắn toàn bộ",
    "全仓开空": "Mở vị thế bán ngắn toàn bộ",
    "可平量为0": "Khả năng đóng vị thế là 0",
    "激活价格": "Giá kích hoạt",
    "状态": "Trạng thái",
    "未激活": "Chưa kích hoạt",
    "已激活": "Đã kích hoạt",
    "回调率": "Tỷ lệ gọi lại",
    "仓位ID": "ID vị thế"
  };
  export const dialog = {
    "前往设置": "Điều chỉnh cài đặt",
  "提示": "Mẹo",
  "确定": "Xác nhận",
  "取消": "Hủy bỏ",
  "确认要全部平仓吗": "Xác nhận bạn muốn đóng tất cả vị thế với giá thị trường và hủy bỏ tất cả lệnh đặt?",
  "确认要全部撤单吗": "Xác nhận bạn muốn hủy bỏ tất cả lệnh đặt?",
  "确认要一键平仓吗": "Xác nhận bạn muốn đóng tất cả vị thế một cách tự động?",
  "确认要一键平仓": "Xác nhận một chạm để đóng tất cả vị thế và hủy bỏ mối quan hệ sao chép?",
  "确认要市价平仓吗": "Xác nhận bạn muốn đóng tất cả vị thế với giá thị trường?",
  "确认要限价平仓吗": "Xác nhận bạn muốn đóng tất cả vị thế với giá giới hạn?",
  "需先设置总跟单账户": "Bạn cần thiết lập tài khoản sao chép tổng trước khi bật chế độ sao chép",
  "加仓": "Mở thêm vị thế",
  "不能为空": "Không được để trống",
  "必须为数字值": "Phải là giá trị số",
  "数字不能小于等于0": "Số không được nhỏ hơn hoặc bằng 0",
  "请输入正确的杠杆倍数": "Vui lòng nhập số lần đòn bẩy đúng",
  "无法切换仓位模式": "Không thể chuyển đổi chế độ vị thế",
  "当前账户没有权限": "Tài khoản hiện tại không có quyền truy cập",
  "swap001": "Hiện tại có vị thế mở, không thể chuyển đổi chế độ vị thế",
  "需全部平仓后可重新设置": "Cần đóng hết vị thế trước khi có thể đặt lại số tiền và lợi suất sao chép",
  "按张数": "Theo số lô",
  "按金额": "Theo số tiền",
  "按比例": "Theo tỷ lệ",
  "按价格": "Theo giá",
  "张": "Lô",
  "预计加仓金额": "Dự kiến số tiền mở thêm vị thế",
  "预计加仓张数": "Dự kiến số lô mở thêm vị thế",
  "持仓数量": "Số lượng vị thế",
  "开仓价格": "Giá mở vị thế",
  "确认要反向开仓吗": "Xác nhận bạn muốn mở vị thế ngược lại không?",
  "预计平仓金额": "Dự kiến số tiền đóng vị thế",
  "预计平仓比例": "Dự kiến tỷ lệ đóng vị thế",
  "预计平仓张数": "Dự kiến số lô đóng vị thế",
  "比例不可以大于": "Tỷ lệ không được lớn hơn",
  "比例不可以小于": "Tỷ lệ không được nhỏ hơn",
  "部分平仓": "Đóng một phần vị thế",
  "确认撤单吗": "Xác nhận bạn muốn hủy bỏ lệnh đặt?",
  "确认要平仓吗": "Xác nhận bạn muốn đóng vị thế?",
  "盈亏": "Lãi/lỗ",
  "当前止损价": "Giá dừng lỗ hiện tại",
  "预估止损价": "Giá dừng lỗ ước tính",
  "亏损": "Lỗ",
  "止损修改": "Sửa đổi giá dừng lỗ",
  "止损比例": "Tỷ lệ dừng lỗ",
  "止损价格": "Giá dừng lỗ",
  "当前盈利价": "Giá lãi hiện tại",
  "预估止盈价": "Giá lãi ước tính",
  "收益": "Lãi",
  "止盈修改": "Sửa đổi giá lãi",
  "止盈比例": "Tỷ lệ lãi",
  "止盈价格": "Giá lãi",
  "请输入加仓数": "Vui lòng nhập số lô mở thêm vị thế",
  "请输入金额": "Vui lòng nhập số tiền",
  "请输入止盈价格": "Vui lòng nhập giá lãi",
  "请输入止盈比例": "Vui lòng nhập tỷ lệ lãi",
  "请输入止损价格": "Vui lòng nhập giá dừng lỗ",
  "请输入止损比例": "Vui lòng nhập tỷ lệ dừng lỗ",

  'BTC/USDT账户模式': 'Mô hình tài khoản BTC/USDT',
  账户模式: 'Mô hình tài khoản',
  调整仓位模式: 'Mô hình điều chỉnh vị thế',
  保证金模式: 'Mô hình Margin',
  仓位模式: 'Mô hình vị thế',
  调整保证金模式: 'Mô hình điều chỉnh Margin áp dụng cho tất cả hợp đồng USDT',
  调整仓位合并模式: 'Mô hình hợp nhất vị thế áp dụng cho tất cả hợp đồng USDT',
  全仓模式: 'Mô hình toàn bộ vị thế',
  仓位合并: 'Vị thế hợp nhất',
  逐仓: 'Vị thế đơn',
  全仓: 'Toàn bộ',
  合仓: 'Hợp nhất',
  分仓: 'Phân chia',
  swap002:
    'Trong chế độ Vị thế đơn, người dùng có thể giữ vị thế cả hai chiều, rủi ro của vị thế bán và vị thế mua được tính độc lập. Khi người dùng phá sản, chỉ mất mát tiền đặt cọc vị thế; khi người dùng tự động đóng vị thế, lợi nhuận và lỗ của vị thế bán và vị thế mua sẽ được thanh toán ngay lập tức vào tiền đặt cọc vị thế tương ứng.',
  全仓模式下所有仓位将共享合约账户的可用保证金:
    'Trong mô hình toàn bộ, tất cả vị thế sẽ chia sẻ toàn bộ tiền đặt cọc có sẵn trong tài khoản hợp đồng, nếu có tình trạng phá sản có thể mất hết vị thế và tiền đặt cọc có sẵn. Hãy chú ý đến rủi ro giữ vị thế!',
  合仓提示: '',
  分仓提示: '',
  不再提示: 'Không hiển thị lại',

  biking合约用户使用协议: 'Hiệp đồng sử dụng của người dùng biking',
  综述:
    '<b>1. Tổng quan</b><br><br>' +
    '<span>' +
    '1.1 Hợp đồng vĩnh viễn ("Dịch vụ này") là sản phẩm phái sinh tài sản ảo do "biking" phát triển. "biking" chịu trách nhiệm về thiết kế sản phẩm và quản lý dịch vụ sàn giao dịch. ' +
    'Để sử dụng hợp đồng vĩnh viễn của "biking", bạn cần đọc và tuân theo "Hiệp đồng sử dụng hợp đồng vĩnh viễn của biking" ("Hiệp đồng này"). Hãy đảm bảo bạn đọc kỹ, hiểu đúng nội dung các điều khoản và chọn chấp nhận hoặc từ chối Hiệp đồng này.' +
    '<br><br>' +
    '1.2 Trừ khi bạn đã đọc và chấp nhận tất cả các điều khoản của Hiệp đồng này, bạn sẽ không có quyền sử dụng Hợp đồng vĩnh viễn của "biking" và các dịch vụ tương ứng. Hành động chấp nhận Hiệp đồng này và việc bạn sử dụng Dịch vụ này sẽ được coi là bạn đã đọc và đồng ý tuân theo các điều khoản của Hiệp đồng này.' +
    '</span>' +
    '<br><br>' +
    '<b>2. Điều kiện sử dụng Dịch vụ này</b>' +
    '<br><br>' +
    '<span>2.1 Bạn hiểu và xác nhận:' +
    '<br>' +
    'Bạn đã đồng ý tuân theo "Điều khoản dịch vụ của biking", đồng thời bạn đủ điều kiện và không bị cấm sử dụng "Dịch vụ" được xác định trong đó;' +
    '<br>' +
    'Hiệp đồng này không xung đột với pháp luật của quốc gia hoặc khu vực bạn đang ở;' +
    '<br>' +
    'Bạn là chủ sở hữu hợp pháp của tài sản ảo được gửi vào Dịch vụ này và đảm bảo nguồn gốc của tài sản ảo này là hợp pháp.' +
    '<br><br>' +
    '2.2 Bạn hiểu rõ về rủi ro khi sử dụng Dịch vụ này, bao gồm nhưng không giới hạn:' +
    '<br>' +
    'Giá của tài sản ảo và sản phẩm phái sinh của chúng có thể biến động mạnh trong khoảng thời gian ngắn và có thể gây mất mát lớn hoặc toàn bộ;' +
    '</span>',
  我已阅读并同意上述协议: 'Tôi đã đọc và đồng ý với Hiệp đồng trên',

  调整杠杆: 'Điều chỉnh đòn bẩy',
  杠杆倍数: 'Leverage',
  当前杠杆倍数最大可开: 'Đòn bẩy hiện tại tối đa có thể mở:',
  '当前仓位所需保证金：': 'Tiền đặt cọc hiện tại cần cho vị thế:',

  交易单位切换: 'Chuyển đổi Đơn vị Giao dịch',
  成交类型切换: 'Chuyển đổi Loại Giao dịch',
  限价: 'Giới hạn giá',
  市价: 'Thị trường giá',
  数字范围必须在: 'Phạm vi số phải nằm trong khoảng từ 1 đến 100',
  请输入平仓数: 'Vui lòng nhập số lượng đóng vị thế',
  请输入平仓比例: 'Vui lòng nhập tỷ lệ đóng vị thế',
  请输入整数: 'Vui lòng nhập số nguyên',
  以当前最优价格交易: 'Giao dịch với giá tốt nhất hiện tại',
  请输入格式正确的杠杆倍数: 'Vui lòng nhập đúng định dạng đòn bẩy',
  杠杆倍数提示: 'Đòn bẩy hiện tại khá cao, hãy chú ý đến rủi ro.',
  下单二次确认: 'Xác nhận Lệnh mua',
  平仓二次确认: 'Xác nhận Đóng vị thế',
  下单确认: 'Xác nhận Lệnh mua',
  二次确认不展示: 'Không hiển thị lại (Bạn có thể bật lại trong "Cài đặt ưa thích")',
  切换交易单位: 'Chuyển đổi Đơn vị Giao dịch',
  偏好设置: 'Cài đặt ưa thích',
  仓位止盈止损: 'Chốt lời/cắt lỗ vị thế',
  移动止盈止损: 'Chuyển động Chốt lời/cắt lỗ',
  止盈止损提示:
    'Chức năng Chuyển động Chốt lời/cắt lỗ được sử dụng để đóng vị thế, nghĩa là khi thị trường phát triển theo hướng tích cực, để bảo vệ lợi nhuận của người giao dịch, khi thị trường điều chỉnh, người giao dịch sẽ đặt lệnh theo chiến lược đã thiết lập của mình. Khi giá thị trường hiện tại đạt đến giá kích hoạt được thiết lập, lệnh sẽ được kích hoạt; khi giá thị trường đạt đến giá cao nhất (thấp nhất) đã được người giao dịch thiết lập sau khi điều chỉnh (1± tỷ lệ điều chỉnh), lệnh sẽ được kích hoạt và giá thực hiện sẽ là giá cao nhất (thấp nhất) đã thiết lập sau khi điều chỉnh (1± tỷ lệ điều chỉnh).',
  最新成交价: 'Giá thực hiện mới nhất',
  设置止盈: 'Thiết lập Chốt lời',
  设置止损: 'Thiết lập Cắt lỗ',
  预计盈利: 'Ước lượng lợi nhuận',
  预计亏损: 'Ước lượng lỗ',
  调整保证金: 'Điều chỉnh Tiền đặt cọc',
  增加: 'Tăng',
  减少: 'Giảm',
  最大: 'Tối đa',
  当前仓位保证金: 'Tiền đặt cọc hiện tại của vị thế',
  最大可增加: 'Tối đa có thể tăng',
  最大可减少: 'Tối đa có thể giảm',
  调整后参考强评价: 'Giá định giá mạnh sau khi điều chỉnh',
  请输入保证金: 'Vui lòng nhập số tiền đặt cọc',
  强平价格: 'Giá định giá mạnh',
  开仓数量: 'Số lượng mở vị thế',
  计算: 'Tính toán',
  计算结果: 'Kết quả tính toán chỉ mang tính chất tham khảo',
  回调率: 'Tỷ lệ điều chỉnh',
  请输入回调率: 'Vui lòng nhập tỷ lệ điều chỉnh',
  仓位数量: 'Số lượng vị thế',
  激活价: 'Giá kích hoạt',
  请输入激活价: 'Vui lòng nhập giá kích hoạt',
  激活做多提示: 'Hướng mua cần cao hơn giá thực hiện mới nhất',
  激活做空提示: 'Hướng bán cần thấp hơn giá thực hiện mới nhất',
  };
  export const codeInfo = {
    永续合约: 'Hợp đồng vĩnh viễn',
    标记价格: 'Giá đánh dấu',
    指数价格: 'Giá chỉ số',
    指数价格提示:
      'Giá chỉ số thời gian thực của hợp đồng này. Giá này sẽ được sử dụng trong việc tính toán giá dự kiến của vị thế để tránh đồng giá với giá giao dịch cuối cùng của hợp đồng và tránh tình trạng làm giá.',
    '24H最高': '24H Cao nhất',
    '24H最低': '24H Thấp nhất',
    资金费率: 'Tỷ lệ phí cho kỳ tính phí này',
    距费用结算: 'Còn lại thời gian đến kỳ tính phí này kết thúc',
    我的赠金: 'Tiền thưởng của tôi',
 };
  export const panKou = {
    交易深度: 'Sâu lược giao dịch',
    实时成交: 'Giao dịch thời gian thực',
    张: 'Chỗ',
    保证金: 'Tiền đặt cọc',
    价格: 'Giá',
    数量: 'Số lượng',
    时间: 'Thời gian',
    累计: 'Tích lũy',
 };
  export const placeOrder = {
    立即去玩:"bắt đầu",
    全仓: 'Toàn bộ',
    逐仓: 'Từng vị trí',
    杠杆: 'Đòn bẩy',
    开多: 'Mở nhiều',
    开空: 'Mở rỗng',
    市价委托: 'Thị trường',
    限价委托: 'Giới hạn giá',
    计划委托: 'Kế hoạch',
    价格: 'Giá',
    数量: 'Số lượng',
    限价: 'Giới hạn giá',
    市价: 'Thị trường',
    止盈止损: 'Chốt lời/cắt lỗ',
    张: 'Chỗ',
    开仓价: 'Giá mở cửa',
    触发价: 'Giá kích hoạt',
    执行价: 'Giá thực hiện',

    收益: 'Lợi nhuận',
    按比例设置: 'Thiết lập theo tỷ lệ',
    按价格设置: 'Thiết lập theo giá',
    亏损: 'Lỗ',

    swap003: 'Mua/Đầu cơ lên',
    swap004: 'Bán/Đầu cơ xuống',
    买入: 'Mua',
    卖出: 'Bán',
    做多: 'Đầu cơ lên',
    做空: 'Đầu cơ xuống',
    可用: 'Có sẵn',
    可做多: 'Có thể đầu cơ lên',
    可做空: 'Có thể đầu cơ xuống',

    资产: 'Tài sản',
    持仓保证金: 'Tiền đặt cọc vị thế',
    未实现盈亏: 'Lợi nhuận và lỗ chưa thực hiện',
    净值: 'Giá trị ròng',
    可用保证金: 'Tiền đặt cọc có sẵn',
    账户余额: 'Số dư tài khoản',
    风险率: 'Tỷ lệ rủi ro',

    合约信息: 'Thông tin hợp đồng',
    指数来源: 'Nguồn chỉ số',
    合约面值: 'Giá trị hợp đồng',
    资金费率: 'Tỷ lệ phí',
    最大杠杆: 'Đòn bẩy tối đa',
    下单方向可开张数的: 'Số chỗ mở theo hướng đặt lệnh',

    立即注册: 'Đăng ký ngay',
    登录: 'Đăng nhập',
    swap005: 'Tài sản (Hợp đồng vĩnh viễn)',
    登录以查看: 'Đăng nhập để xem',

    请输入数量: 'Vui lòng nhập số lượng',
    请输入价格: 'Vui lòng nhập giá',
    请输入限价: 'Vui lòng nhập giới hạn giá',
    请输入止盈止损: 'Vui lòng nhập lệnh chốt lời/cắt lỗ',
    '止损率不能大于90%': 'Tỷ lệ lỗ không thể lớn hơn 90%',
    止损价格不能大于: 'Giá chốt lỗ không thể lớn hơn',
    开通合约账号: 'Mở tài khoản hợp đồng',
    账号冻结: 'Tài khoản bị đóng băng',
    '止盈率不能大于1000%': 'Tỷ lệ chốt lời không thể lớn hơn 1000%',
    请输入触发价: 'Vui lòng nhập giá kích hoạt',
    保证金: 'Tiền đặt cọc',
    体验金: 'Tiền thưởng trải nghiệm',
    不使用体验金: 'Không sử dụng tiền thưởng trải nghiệm',
    查看详情: 'Xem chi tiết',
    委托保证金: 'Tiền đặt cọc lệnh',
    币: 'Đồng',
    计算器: 'Máy tính',
    划转: 'Chuyển khoản'
  };
  export const codelist = {
    搜索: 'Tìm kiếm',
    全部: 'Tất cả',
    交易对: 'Cặp giao dịch',
    最新价: 'Giá mới nhất',
    涨幅: 'Tăng giảm',
    自选: 'Tự chọn',
    添加自选成功: 'Thêm vào tự chọn thành công',
    取消自选成功: 'Hủy tự chọn thành công',
  };
  export const merchandiser = {
    我的实盘: "Tài khoản Thực tế của tôi",
    与优秀的交易员共同赚钱: "Kiếm tiền cùng các nhà giao dịch xuất sắc",
    code_00051: "Cộng đồng Copy Trading",
    个人中心: 'Trung tâm cá nhân',
    更多服务: 'Dịch vụ khác',
    钱包: "Ví",
    衍生品: 'Sản phẩm tài chính',
    跟单设置: 'Cài đặt Sao lưu',
    跟单: 'Sao lưu',
    跟单提示: 'Dữ liệu được cập nhật mỗi giờ',
    我的跟单: 'Sao lưu của tôi',
    成为交易员: 'Trở thành nhà giao dịch',
    综合排名: 'Xếp hạng Tổng hợp',
    收益率: 'Tỉ suất lợi nhuận',
    近3周收益: 'Lợi nhuận gần đây 3 tuần',
    近3周胜率: 'Tỉ lệ chiến thắng gần đây 3 tuần',
    总收益: 'Tổng lợi nhuận',
    累计收益率: 'Tổng tỷ suất lợi nhuận',
    累计跟随人数: 'Tổng số người theo dõi',
    跟随中: 'Đang theo dõi',
    AUM: 'Tài sản quản lý',
    当前跟谁: 'Đang theo dõi ai',
    搜索交易员: 'Tìm kiếm nhà giao dịch',
    满员: 'Đã đủ người',
    申请成为交易员: 'Đăng ký trở thành nhà giao dịch',
    手机号: 'Số điện thoại',
    邮箱: 'Email',
    请输入邮箱: 'Vui lòng nhập Email',
    邮箱错误: 'Vui lòng nhập Email đúng',
    请输入手机号: 'Vui lòng nhập số điện thoại',
    手机号错误: 'Vui lòng nhập số điện thoại đúng',
    请输入正确数值: 'Vui lòng nhập giá trị đúng',
    申请交易员提示文案: 'Đăng ký trở thành nhà giao dịch có thể nhận chia sẻ lợi nhuận từ việc sao lưu',
    跟单确认: 'Xác nhận Sao lưu',
    我已同意跟单协议: 'Tôi đã đọc và đồng ý với điều khoản Sao lưu',
    跟单协议: '《Thỏa thuận Sao lưu》',
    申请跟单提示文案: "Hiệu ứng này được thiết lập bởi bạn (gọi là 'bạn' hoặc 'bạn của bạn') và Binance. Bạn truy cập, sử dụng hoặc bất kỳ dịch vụ nào được cung cấp bởi Binance hoặc bất kỳ trang web nào thuộc sở hữu của Binance, ứng dụng di động được cung cấp bởi Binance hoặc các dịch vụ khác liên quan khác được mô tả chi tiết trong mục 4 dưới đây, trang web của Binance hoặc bất kỳ trang web nào thuộc sở hữu của các tổ chức thuộc sở hữu của Binance (gọi chung là 'Dịch vụ này'), điều này đồng nghĩa với việc bạn xác nhận rằng bạn đã đọc, hiểu và chấp nhận tất cả các điều khoản và điều kiện được quy định trong Thỏa thuận Sử dụng này (gọi tắt là 'Thỏa thuận Sử dụng') và bảng tuyên bố về quyền riêng tư chúng tôi công bố trên nền tảng. Ngoài ra, khi sử dụng một số chức năng cụ thể của Dịch vụ này, bạn có thể cần tuân thủ các điều khoản và điều kiện bổ sung áp dụng cho các chức năng đó.",
    申请跟单提示文案1: "1. Sao lưu theo nhà giao dịch có thể mang lại rủi ro lỗ nếu nhà giao dịch mất lợi nhuận; rủi ro này sẽ do người theo dõi tự chịu.",
    申请跟单提示文案2: "2. Nền tảng Binance hỗ trợ người theo dõi sử dụng tài khoản Sao lưu để sao lưu theo dõi nhà giao dịch. Người theo dõi có thể sử dụng tài khoản Hợp đồng để tự mở lệnh. Trong thời gian này, tài khoản Sao lưu sẽ không bị ảnh hưởng.",
    申请跟单提示文案3: "3. Sau khi bắt đầu theo dõi, chỉ có những vị trí mới mở của nhà giao dịch được theo dõi, những vị trí hiện có không được theo dõi. Bạn có thể hủy theo dõi bất cứ lúc nào, nhưng hủy theo dõi không ảnh hưởng đến các đơn đặt hàng đã theo dõi và bạn có thể đóng chúng thủ công.",
    申请跟单提示文案4: "4. Trong quá trình theo dõi, việc điều chỉnh vị trí Sao lưu sẽ khiến bạn rời khỏi chế độ theo dõi;",
    申请跟单提示文案5: "5. Khi giao dịch viên theo dõi đóng lời nhuận, 12% lợi nhuận sẽ được chia cho nhà giao dịch Sao lưu làm thưởng.",
    申请跟单提示文案6: "6. Sao lưu theo nhà giao dịch có thể mang lại rủi ro lỗ; hãy lựa chọn cẩn thận và chú ý kiểm soát rủi ro và hiểu biết về rủi ro theo dõi.",
    申请跟单提示文案7: "7. Khi đơn đặt hàng của nhà giao dịch được xác định là giao dịch vi phạm và bị hủy bỏ, bạn sẽ không thể theo dõi mở vị trí mới. Những vị trí đã theo dõi không bị ảnh hưởng, nhưng sau đó bạn sẽ rời khỏi chế độ theo dõi.",
    申请跟单提示文案8: "8. Nhà giao dịch có quyền loại bỏ người theo dõi. Sau khi bị loại bỏ, bạn sẽ không thể theo dõi mở vị trí mới, những vị trí đã theo dõi không bị ảnh hưởng.",
    搜索您的国家名或国家区号: 'Tìm quốc gia hoặc mã khu vực của bạn',
    我已同意成为交易员: 'Tôi đã đọc và đồng ý trở thành nhà giao dịch',
    请勾选: 'Vui lòng chọn',
    申请交易员失败提示: 'Bạn đang theo dõi tất cả, tạm thời không thể đăng ký trở thành nhà giao dịch. Vui lòng dừng tất cả theo dõi trước khi đăng ký.',
    我知道了: 'Tôi đã biết',
    今日收益: 'Lợi nhuận hôm nay',
    累计收益: 'Lợi nhuận tích lũy',
    交易员分成: 'Chia sẻ lợi nhuận của nhà giao dịch',
    待结算分成: 'Lợi nhuận chờ thanh toán',
    已结算分成: 'Lợi nhuận đã thanh toán',
    当前跟单: 'Sao lưu hiện tại',
    历史跟单: 'Sao lưu lịch sử',
    我的交易员: 'Nhà giao dịch của tôi',
    编辑: 'Chỉnh sửa',
    平仓均价: 'Giá trung bình đóng cửa',
    持仓均价: 'Giá trung bình mở cửa',
    开仓时间: 'Thời gian mở cửa',
    平仓时间: 'Thời gian đóng cửa',
    预估暴仓价: 'Giá dự kiến của vị trí bán sạch',
    交易员: 'Nhà giao dịch',
    详情: 'Chi tiết',
    仓位ID: 'ID vị trí',
    空位提醒: 'Nhắc nhở vị trí trống',
    空位提醒内容: 'Số lượng người theo dõi của nhà giao dịch đã đầy, bạn sẽ nhận được một lời nhắc khi nhà giao dịch không đầy.',
    当前跟随: 'Hiện đang theo dõi',
    跟随人数数据: '{v1}/{v2} người',
    跟随人数: 'Số người theo dõi',
    总权益: 'Tổng quyền lợi',
    带单合约: 'Hợp đồng Sao lưu',
    交易数据: 'Dữ liệu giao dịch',
    交易笔数: 'Số lệnh giao dịch',
    盈利笔数: 'Số lệnh lợi nhuận',
    亏损笔数: 'Số lệnh lỗ',
    扛单比例: 'Tỷ lệ giữ lệnh',
    平均扛单率: 'Tỷ lệ giữ lệnh trung bình',
    最大扛单率: 'Tỷ lệ giữ lệnh tối đa',
    订单: 'Đơn đặt hàng',
    跟随者: 'Người theo dõi',
    跟随者收益: 'Lợi nhuận của người theo dõi',
    跟随用户: 'Người theo dõi',
    跟随总额: 'Tổng số người theo dõi',
    跟随收益: 'Lợi nhuận của người theo dõi',
    交易员订单本金: 'Vốn đầu tư của nhà giao dịch',
    当前带单: 'Sao lưu hiện tại',
    历史带单: 'Sao lưu lịch sử',
    跟单数据统计: 'Thống kê giao dịch sao chép',
    不用了: 'Không cần nữa',
    设置提醒成功: 'Thiết lập nhắc nhở thành công',
    我的带单: 'Sao lưu của tôi',
    查看主页: 'Xem trang chủ',
    利润分成比例: 'Tỉ lệ chia sẻ lợi nhuận',
    跟随交易员: 'Theo dõi nhà giao dịch',
    仓位类型: 'Loại vị trí',
    指定杠杆: 'Xác định đòn bẩy',
    请输入杠杆: 'Vui lòng nhập đòn bẩy',
    单笔倍率: 'Tỷ lệ đòn bẩy mỗi lần giao dịch',
    单笔金额: 'Số tiền mỗi lần giao dịch',
    固定额度: 'Số tiền cố định',
    请输入单笔金额1: 'Vui lòng nhập số tiền cố định không dưới 5U',
    请输入单笔金额: 'Vui lòng nhập số tiền Sao lưu từ {v1} đến {v2}',
    请输入单笔倍率: 'Vui lòng nhập tỷ lệ Sao lưu từ {v1} đến {v2}',
    每次下单折合U: 'Mỗi lần giao dịch mở cửa sẽ yêu cầu {v1} USDT bảo đảm',
    每次下单倍数: 'Số lượng giao dịch mỗi lần Sao lưu là {v1} lần số lượng giao dịch của nhà giao dịch',
    倍率: 'Tỉ lệ',
    跟单本金: 'Số vốn theo dõi',
    总跟单保证金: 'Tổng số tiền đặt cọc theo dõi',
    请输入跟单本金: 'Vui lòng nhập số vốn theo dõi',
    资产账户: 'Tài khoản tài sản {v1} USDT',
    合约账户: 'Tài khoản hợp đồng {v1} USDT',
    风险控制: 'Kiểm soát rủi ro',
    设置: 'Cài đặt',
    保存: 'Lưu',
    取消跟随: 'Hủy theo dõi',
    移除跟随: 'Loại bỏ theo dõi',
    交易员保证金: 'Tiền đặt cọc của nhà giao dịch',
    请输入交易员保证金: 'Vui lòng nhập tiền đặt cọc của nhà giao dịch',
    风险设置提示: 'Khi số vốn mở vị trí theo dõi của bạn đạt đến giá trị này, bạn sẽ không thể theo dõi lệnh mới nữa.',
    关闭带单: 'Đóng Sao lưu',
    我的跟随者: 'Người theo dõi của tôi',
    带单设置: 'Cài đặt Sao lưu',
    预计利润分成: 'Ước tính lợi nhuận chia sẻ',
    利润分成: 'Lợi nhuận chia sẻ',
    开启成功: 'Mở thành công',
    开启失败: 'Mở thất bại',
    关闭成功: 'Đóng thành công',
    关闭失败: 'Đóng thất bại',
    确认取消吗: 'Bạn có chắc muốn hủy theo dõi không?',
    条件一: 'Không có vị trí, lệnh hiện tại, lệnh kế hoạch trong hợp đồng',
    条件二: 'Số dư khả dụng trong tài khoản hợp đồng >= {v} USDT',
    条件三: 'Không có vị trí trong hợp đồng',
    最大回撤: 'Rút lui tối đa',
    平均持仓时间: 'Thời gian giữ vị trí trung bình',
    正在跟随: 'Đang theo dõi',
    历史跟随: 'Lịch sử theo dõi',
    累计跟单: 'Tổng số lệnh Sao lưu',
    累计分成: 'Tổng số tiền chia sẻ',
    笔: 'Ghi chú',
    上一页: 'Trang trước',
    下一页: 'Trang sau',
    返回: 'Quay lại',
    今日预估收益: 'Ước tính lợi nhuận hôm nay',
    账户权益: 'Quyền lợi của tài khoản',
    将账户权益展示在个人信息页面: 'Hiển thị quyền lợi tài khoản trên trang thông tin cá nhân',
    带单本金: 'Số vốn Sao lưu',
    每次开仓均会展示带单本金: 'Mỗi lần mở vị trí đều hiển thị số vốn Sao lưu',
    隐藏挂单价:'Ẩn giá lệnh chờ xử lý',
    带单币对: 'Sao lưu cặp tiền',
    入住时间: 'Thời gian Sao lưu',
    保存成功: 'Lưu thành công',
    取消成功: 'Hủy thành công',
    设置成功: 'Cài đặt thành công',
    跟单合约: 'Hợp đồng Sao lưu',
    历史委托: 'Lịch sử đặt cọc',
    成交数量: 'Số lượng giao dịch',
    触发时间: 'Thời gian kích hoạt',
    开启带单: 'Mở Sao lưu',
    账户已冻结: 'Tài khoản đã bị đóng băng, vui lòng liên hệ dịch vụ khách hàng',
    审核中: 'Đang chờ duyệt',
    小时: '{v} giờ',
    累计分润: 'Tổng số tiền chia sẻ',
    今日预估分润: 'Ước tính lợi nhuận hôm nay',
    交易协议: '《Thỏa thuận giao dịch》',
    带单协议: '《Thỏa thuận Sao lưu》',
    追加跟单本金: 'Thêm số vốn theo dõi',
    提示: 'Lời nhắc:',
    提示信息: 'Lợi nhuận được thanh toán mỗi ngày bắt đầu từ 0 giờ và sẽ hoàn thành trước 1 giờ, sau đó tự động chuyển vào tài khoản hợp đồng của bạn; Nếu bạn có vị trí Sao lưu trong thời gian thanh toán, lợi nhuận sẽ được thanh toán vào buổi sáng ngày giao dịch tiếp theo.',
    合约跟单: 'Hợp đồng Sao lưu',
    跟单文字: 'Tại Biking, kiếm tiền cùng các nhà giao dịch hàng đầu trên thế giới',
    查看牛人实盘: 'Xem tài khoản thực của các nhà giao dịch tài năng',
    捕捉市场信号: 'Bắt kịp tín hiệu thị trường',
    复制高手收益: 'Sao chép lợi nhuận của các chuyên gia',
    跟单指南: 'Hướng dẫn theo dõi',
    跟单广场: 'Quảng trường Sao lưu',
    跟单总收益: 'Tổng lợi nhuận Sao lưu',
    丰厚分润收入: 'Thu nhập chia sẻ lợi nhuận hấp dẫn',
    更多平台曝光: 'Nhiều sự xuất hiện trên các nền tảng khác nhau',
    专属交易徽章: 'Huy hiệu giao dịch riêng',
    成为Biking带单交易员: 'Chỉ cần một bước, trở thành nhà giao dịch Sao lưu của Biking',
    享受Biking带单交易员的独家福利: 'Tận hưởng những ưu đãi độc quyền của nhà giao dịch Sao lưu của Biking',
    平台奖励: 'Nhận 12% lợi nhuận Sao lưu',
    联系方式: 'Thông tin liên lạc',
    简介: 'Giới thiệu',
    请输入简介: 'Vui lòng nhập giới thiệu',
    交易能力证明: 'Chứng minh khả năng giao dịch (tùy chọn)',
    选择周期: 'Vui lòng chọn chu kỳ >30 ngày của đường cong lợi nhuận, thống kê dữ liệu giao dịch và cảnh báo; Nếu không tải lên, chúng tôi sẽ mặc định kiểm tra hồ sơ giao dịch của bạn trên EU. Tối đa có thể tải lên 3 hình ảnh, mỗi hình ảnh không quá 10 MB.',
    我已阅读并同意: 'Tôi đã đọc và đồng ý',
    跟单交易服务条款: '《Thỏa thuận dịch vụ Sao lưu》',
    立即申请: 'Đăng ký ngay',
    请输入联系方式: 'Vui lòng nhập thông tin liên lạc',
    联系方式不正确: 'Thông tin liên lạc không đúng!',
    邮箱格式不正确: 'Định dạng email không đúng',
    请输入简介信息: 'Vui lòng nhập thông tin giới thiệu',
    请确认勾选协议: 'Vui lòng xác nhận đã chọn thỏa thuận',
    上传头像图片限制: 'Hình ảnh đại diện không được vượt quá 10MB!',
    最大限制: 'Hiện tại giới hạn tải lên là 3 tệp',
    带单交易员招募中: 'Đang tuyển nhà giao dịch Sao lưu, ngay bây giờ bạn có thể nhận 12% lợi nhuận Sao lưu',
    跟单成功: 'Theo dõi thành công',
    昵称: 'Biệt danh',
    请输入昵称: 'Vui lòng nhập biệt danh',
    申请交易员已提交: 'Đã gửi yêu cầu trở thành nhà giao dịch, vui lòng đợi duyệt'
  };
  export const hyy = {
    bkt: "Không mở",
    wqdkt: "Tôi xác nhận mở",
    kt12: "1. Trước khi tham gia, bạn cần tìm hiểu kỹ về kiến thức cơ bản về giao dịch hợp đồng tiền điện tử và các rủi ro liên quan, cũng như các quy tắc kinh doanh liên quan đến giao dịch hàng hóa phái sinh.",
    kt13: "2. Các mục rủi ro được liệt kê trong Thông báo rủi ro này chỉ mang tính chất mô tả, không thể liệt kê đầy đủ tất cả các yếu tố rủi ro liên quan đến giao dịch hàng hóa phái sinh tài sản số. Trước khi đầu tư vào giao dịch hàng hóa phái sinh tài sản số, nhà đầu tư cũng nên chăm sóc và hiểu rõ về các yếu tố rủi ro khác có thể tồn tại.",
    kt14: "3. Chúng tôi诚挚的 chúc mừng và đề xuất nhà đầu tư, từ tình trạng thực tế của bản thân như khả năng chịu đựng rủi ro, cân nhắc một cách thận trọng xem liệu bạn có nên tham gia giao dịch hợp đồng này hay không, và phân bổ tài sản số của mình một cách hợp lý.",
    kt0: "Quý khách thân mến:",
    kt1: "Quý khách chưa mở tài khoản hợp đồng và quyền giao dịch hợp đồng, vui lòng đọc kỹ nội dung sau đây trước khi quyết định mở:",
    kt2: "Một, khi quý khách giao dịch trên thị trường hợp đồng, nếu xu hướng giá thị trường không thuận lợi cho quý khách dẫn đến số tiền đảm bảo vị thế của quý khách không đủ, hợp đồng vĩnh viễn của BiKing sẽ tự động bán mở vị thế của quý khách và tiết lộ chi tiết thanh toán mở vị thế.",
    kt3: "Hai, quý khách phải đọc và tuân thủ các quy tắc kinh doanh của Hợp đồng vĩnh viễn BiKing, hiểu rõ cơ chế và nguyên lý hoạt động của hợp đồng, và hiểu rõ các rủi ro của thị trường.",
    kt4: "Bốn, Hợp đồng vĩnh viễn của BiKing kết nối hệ thống giao dịch hợp đồng, lợi nhuận và lỗ của người dùng thay đổi theo biến động của thị trường hợp đồng, khi lỗ lớn, cũng sẽ xảy ra bị động mở vị trí trong hệ thống giao dịch hợp đồng. Vui lòng tự quyết định hành vi giao dịch của bạn và tự chịu trách nhiệm về lợi nhuận và lỗ, dựa trên điều này, BiKing không chịu trách nhiệm về bất kỳ trách nhiệm chắc chắn hoặc xác định nào.",
    kt5: "Năm, trong một số tình huống thị trường cực kỳ cụ thể, quý khách có thể sẽ khó khăn hoặc không thể đóng một số lượng hợp đồng mở quý khách đang nắm giữ. Ví dụ, khi lợi nhuận của bạn nằm ở vị trí hàng đầu trong lợi nhuận hiệu quả toàn cầu của thị trường hợp đồng, và đối tác giao dịch của bạn không đủ tài trợ để chi trả cho thiệt hại mở vị trí của họ.",
    kt6: "Sáu, giao dịch hàng hóa phái sinh tài sản số có thể phải đối mặt với rủi ro giám sát chính trị trong một số lãnh thổ pháp lý, quý khách cần cẩn thận đánh giá trước khi tham gia dựa trên sự hiểu biết về nền chính trị giám sát của khu vực giao dịch. Do thay đổi của pháp luật, quy tắc giao dịch của sàn giao dịch hợp đồng, biện pháp khẩn cấp và những lý do khác, BiKing sẽ thông báo trước, quyền lợi của hợp đồng mở vị thế của bạn có thể không thể tiếp tục giữ lại, nhưng tiền đảm bảo và lợi nhuận còn lại sẽ được thanh toán.",
    kt7: "Bảy, do những nguyên nhân mà bên ngoài tầm kiểm soát của bên đối tác, ví dụ: động đất, lụt lụt, cháy cháy và các yếu tố không thể kiểm soát khác hoặc lỗi hệ thống máy tính, lỗi hệ thống liên lạc, có thể khiến cho lệnh của bạn không thể thực hiện hoặc không thể thực hiện đầy đủ, và các thiệt hại có thể phải chịu bởi bạn chính mình.",
    kt8: "Tám, giao dịch 'bảo hiểm rủi ro' cũng như giao dịch đầu cơ, đều phải đối mặt với rủi ro do biến động giá cả gây ra.",
    kta9: "Chín, nếu quý khách không thực hiện xác minh danh tính hoặc chưa liên kết xác minh Google, hoặc chia sẻ tài khoản cho người khác sử dụng không phải là chủ sở hữu, có thể ảnh hưởng đến tính an toàn của tiền đảm bảo hợp đồng của quý khách",
    kta10:
    "Ba, trong một số tình huống thị trường cực kỳ cụ thể, quý khách có thể sẽ khó khăn hoặc không thể đóng một số lượng hợp đồng mở quý khách đang nắm giữ. Ví dụ, khi lợi nhuận của bạn nằm ở vị trí hàng đầu trong lợi nhuận hiệu quả toàn cầu của thị trường hợp đồng, và đối tác giao dịch của bạn không đủ tài trợ để chi trả cho thiệt hại mở vị trí của họ.",
    kt9: "Tôi đã đọc kỹ và sẵn lòng chịu rủi ro",
    kt10: "Mở tài khoản hợp đồng và quyền giao dịch hợp đồng",
    zjhz: "Chuyển vốn",
    ljhz: "Chuyển ngay",
    qx: "Hủy chuyển",
    khz: "Có thể chuyển",
    qxz: "Vui lòng chọn",
    bz: "Loại tiền",
    c: "Từ",
    zz: "Đến",
    sl: "Số lượng",
    qb: "Tất cả",
    ktcg: "Mở thành công",
    ktsb: "Mở thất bại",
    hzcg: "Chuyển thành công",
    hzsb: "Chuyển thất bại",
    wyyd: "", // Không đánh dấu đã đọc thông báo
    tc: "Thoát",
    warning1: "Vui lòng chọn loại tiền",
    warning2: "Tài khoản chuyển ra không thể để trống",
    warning3: "Tài khoản chuyển vào không thể để trống",
    warning4: "Vui lòng nhập số không lớn hơn số lượng có thể chuyển",
    gb: "Đóng",
    openSuccess: "Bạn đã mở giao dịch hợp đồng",
    openSuccessTip: "Vui lòng chuyển vốn vào tài khoản hợp đồng",
    warning5: "Giữ tối đa 4 chữ số thập phân",
    not_get_nm: "Rất tiếc, hoạt động Ni mã đã kết thúc, lần chuyển này không thể nhận Ni mã"
  }

  export const invite = {
    yqfy: "Mời chào hoa hồng",
    yj1: "Chia sẻ liên kết mời, áp phích mời hoặc mã giới thiệu",
    yj2: "Mời bạn bè đăng ký và giao dịch",
    yj3: "Hưởng hoa hồng phí giao dịch",
    yqm: "Mã mời của tôi:",
    yqlj: "Liên kết mời của tôi:",
    fz: "Sao chép",
    fzcg: "Sao chép thành công",
    fzsb: "Sao chép thất bại",
    dlck: "Xem sau khi đăng nhập",
    rs: "Số người đã mời",
    ljbb: "Tổng hoa hồng giao dịch tiền điện tử ({flag})",
    ljeft: "Tổng hoa hồng giao dịch ETF ({flag})",
    ljhy: "Tổng hoa hồng giao dịch hợp đồng ({flag})",
    yhm: "Tên người dùng",
    sfsm: "Đã xác minh danh tính",
    tjsj: "Thời gian giới thiệu",
    zsy: "Tổng thu nhập ({flag})",
    s: "Có",
    f: "Không",
    djjz: "Nhấp để tải thêm",
    ckmx: "Xem chi tiết",
    pm: "Xếp hạng",
    zyqr: "Số người mời hàng tháng",
    zfyj: "Số tiền hoa hồng hàng tháng ({flag})",
    ckbd: "Xem toàn bộ bảng xếp hạng",
    rlues1: "Mời bạn bè đăng ký, hoa hồng dài hạn, tận hưởng thu nhập.",
    rlues2:
    "Mời bạn bè đăng ký để thiết lập mối quan hệ mời, bạn bè thực hiện giao dịch tiền điện tử hoặc ETF đòi lại hoa hồng phí giao dịch của bạn, thu nhập hoa hồng mời không giới hạn.",
    rlues3: "Quy tắc và tỷ lệ hoa hồng mời",
    jylx: "Loại giao dịch",
    yqrfy: "Hoa hồng người mời",
    yqgxyxq: "Thời hạn mối quan hệ mời",
    sixMonth: "6 tháng",
    yj: "Vĩnh viễn",
    bbjy: "Giao dịch tiền điện tử",
    hyjy: "Giao dịch hợp đồng",
    etfjy: "Giao dịch ETF đòi lại hoa hồng",
    gxsj: "Cập nhật dữ liệu hàng tuần",
    xts: "Mẹo nhỏ",
    ts1: "Khi bạn bè đăng ký, họ phải điền mã giới thiệu của bạn, điều này mới được xem là bạn mời thành công!",
    ts2: "Quét mã QR bên trái bằng điện thoại để nhanh chóng mời người dùng.",
    tgzsy: "Tổng thu nhập quảng bá ({flag})",
    cz: "Thao tác",
    fymx: "Chi tiết hoa hồng >",
    zwsj: "Không có bản ghi",
    yh: "Người dùng",
    hqyj: "Nhận hoa hồng mời",
    ysm: "Đã xác minh",
    wsm: "Chưa xác minh",
    hyfymx: "Chi tiết hoa hồng từ bạn bè",
    fylx: "Loại hoa hồng",
    fyje: "Số tiền hoa hồng",
    fysj: "Thời gian hoa hồng",
    mxsyb: "Bảng thu nhập chi tiết",
    zwjy: "Bạn bè này hiện chưa giao dịch, không có hoa hồng phí giao dịch",
    bczxc: "Lưu vào album ảnh",
    rlues4: "Do ảnh hưởng của biến động mạng, một số người dùng có thể trải qua việc hoa hồng chậm đến tài khoản, vui lòng chờ đợi một cách kiên nhẫn.",
    moreRules: "Xem quy tắc chi tiết",
  };
  



// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/vi.js